var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import AlertOctagonSvg from './alert-octagon.icon.svg';
export const AlertOctagonIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: AlertOctagonSvg }));
_react_refresh_temp_1 = AlertOctagonIcon;
$RefreshReg$(_react_refresh_temp_1, "AlertOctagonIcon");
